import apiClient from "@/app/api/client";
import type { AuditDetail } from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

export const auditApi = {
	async get(id: string): Promise<AuditDetail> {
		const response = await apiClient.get<SingleResponse<AuditDetail>>(`/audit/${id}`);

		return response.data.data;
	},
};
